import SEO from '../components/SEO';

export default function DSALabelsPage() {
  return (
    <div className="flex-1 bg-white py-12">
      <SEO
        title="DSA Labels & Compliance | Waybook"
        description="Waybook's Digital Services Act (DSA) compliance information for EU/EEA users and authorities."
        keywords="DSA, Digital Services Act, EU compliance, content moderation, platform transparency"
        canonicalUrl="https://www.waybook.me/dsa-labels"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'DSA Labels & Markings',
          description: 'Digital Services Act compliance information',
          url: 'https://www.waybook.me/dsa-labels'
        }}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-8">DSA Labels & Markings</h1>
        
        <div className="prose max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-4">Digital Services Act Compliance</h2>
            <p className="text-gray-700">
              Waybook aims to comply with the EU Digital Services Act (DSA) and provides
              the following information for users, authorities, and trusted flaggers in the
              EU/EEA.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Platform Information</h2>
            <p className="text-gray-700 mb-3">
              In accordance with the DSA, we provide the following information:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Service provider: Waybook</li>
              <li>Service scope: Global (iOS, Android, Web)</li>
              <li>Single point of contact for authorities: <a href="mailto:legal@waybook.me">legal@waybook.me</a></li>
              <li>Contact for users: <a href="mailto:support@waybook.me">support@waybook.me</a></li>
              <li>Average monthly active recipients of the service in the EU: under assessment; we will publish updated figures in accordance with Article 24(2) DSA.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Content Moderation</h2>
            <p className="text-gray-700">
              We apply proportionate content moderation measures, including user reporting,
              notice‑and‑action, and appeal mechanisms. We remove or restrict content that
              violates EU law or our Terms & Community Guidelines.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Reporting Illegal Content</h2>
            <p className="text-gray-700">
              To report alleged illegal content, use in‑app reporting tools or email
              <a href="mailto:report@waybook.me"> report@waybook.me</a>. Provide a URL, a description of the
              content, and the legal basis for your report.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Transparency Reports</h2>
            <p className="text-gray-700">
              We plan to publish periodic transparency reports summarizing notice‑and‑action
              statistics, moderation actions, and appeals in line with the DSA.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">User Rights</h2>
            <p className="text-gray-700">
              Users have the right to challenge moderation decisions. Information about
              appeals will be provided within the app and via support.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
